<template>
  <ImgPopover v-bind="$attrs" :img-url="imgUrl">
    <a-image
      v-if="imgUrl"
      class="pointer main-img"
      :src="useDealWithPic ? replacePicAlias(imgUrl, 'pclist') : imgUrl"
      :preview-props="({ src: imgUrl } as ImagePreviewProps)"
      :width="width"
      :height="height"
      @click.stop
    />
    <img
      v-else
      class="main-img"
      :style="{ width: width + 'px', height: height + 'px' }"
      src="@/assets/images/no-content-img.png"
      @click.stop
    />
  </ImgPopover>
</template>

<script lang="ts" setup>
  import { replacePicAlias } from '@/utils/common';
  import type { ImagePreviewProps } from '@arco-design/web-vue/es/image/interface';

  defineProps({
    imgUrl: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: '30',
    },
    height: {
      type: [Number, String],
      default: '30',
    },
    useDealWithPic: {
      type: Boolean,
      default: true,
    },
  });
</script>

<script lang="ts">
  export default {
    // 列表用于鼠标悬浮图片放大图片显示
    name: 'ListImgPopover',
  };
</script>

<style lang="less" scoped></style>
